import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClienteEditarComponent } from './cliente-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ClienteEditarComponent }
    ])],
    exports: [RouterModule]
})
export class ClienteEditarRoutingModule { }
